import { Component, input } from '@angular/core';

import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

/**
 * What a grid shows instead of rows (#199): the spinner while a load is in flight, so an
 * in-flight load is never mistaken for "no data", and the empty text once it has settled.
 *
 *   <ng-template kendoGridNoRecordsTemplate>
 *     <app-grid-no-records [loading]="list.loading" loadingText="Aufträge werden geladen…" i18n-loadingText>
 *     </app-grid-no-records>
 *   </ng-template>
 *
 * Thirteen grids carried this as their own `@if`, each with its own CSS class for the margin.
 */
@Component({
  selector: 'app-grid-no-records',
  imports: [LoadingSpinnerComponent],
  template: `
    @if (loading()) {
      <app-loading-spinner class="grid-no-records__loading" [text]="loadingText()"></app-loading-spinner>
    } @else {
      <span>{{ emptyText() }}</span>
    }
  `,
  styles: ['.grid-no-records__loading { margin: 1.5rem 0; }'],
})
export class GridNoRecordsComponent {
  readonly loading = input(false);
  readonly loadingText = input<string>();
  readonly emptyText = input<string>($localize`Keine Daten vorhanden`);
}
